class DemyrGallery {
  constructor() {
    this.gallery = document.querySelector("media-gallery");

    if (!this.gallery) return;

    this.viewer = this.gallery.querySelector('[id^="GalleryViewer"]');

    this.thumbContainer = this.gallery.querySelector('[id^="GalleryThumbnails-"]');

    this.thumbnailList = this.gallery.querySelector(".demyr-thumbnail-list");

    this.thumbnails = this.gallery.querySelectorAll(".thumbnail");

    this.prevButton = this.gallery.querySelector(".demyr-arrow--up");
this.nextButton = this.gallery.querySelector(".demyr-arrow--down");

    this.bindScroll();
    this.watchActiveThumbnail();
    this.updateArrowVisibility();

this.thumbnailList?.addEventListener("scroll", () => {
  this.updateArrowVisibility();
});

window.addEventListener("resize", () => {
  this.updateArrowVisibility();
});
  }

  bindScroll() {
    if (
      !this.thumbnailList ||
      !this.prevButton ||
      !this.nextButton
    ) {
      return;
    }

    const step = 97;

    this.prevButton.addEventListener("click", (e) => {
      e.preventDefault();

      this.thumbnailList.scrollBy({
        top: -step,
        behavior: "smooth",
      });
      setTimeout(() => this.updateArrowVisibility(), 250);
    });

    this.nextButton.addEventListener("click", (e) => {
      e.preventDefault();

      this.thumbnailList.scrollBy({
        top: step,
        behavior: "smooth",
      });
      setTimeout(() => this.updateArrowVisibility(), 250);
    });
  }

  watchActiveThumbnail() {
    this.thumbnails.forEach((thumb) => {
      thumb.addEventListener("click", () => {

        this.thumbnails.forEach((t) =>
          t.removeAttribute("aria-current")
        );

        thumb.setAttribute("aria-current", "true");

      });
    });
  }
  updateArrowVisibility() {

  if (!this.thumbnailList) return;

  const maxScroll =
    this.thumbnailList.scrollHeight - this.thumbnailList.clientHeight;

  if (this.prevButton) {
    this.prevButton.style.visibility =
      this.thumbnailList.scrollTop <= 0 ? "hidden" : "visible";
  }

  if (this.nextButton) {
    this.nextButton.style.visibility =
      this.thumbnailList.scrollTop >= maxScroll - 2 ? "hidden" : "visible";
  }

}
}

document.addEventListener("DOMContentLoaded", () => {
  new DemyrGallery();
});